/**
 * CreateCategoryModal - Create Category Inline - extraído VERBATIM de ProductsContent.js (Fase 2 refactor).
 * Recebe estado/handlers via props do closure de ProductsContent.
 */
import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

const CreateCategoryModal = ({
  isCreateCategoryModalOpen,
  setIsCreateCategoryModalOpen,
  newCategoryData,
  setNewCategoryData,
  creatingCategory,
  handleCreateCategoryInline,
  COLOR_OPTIONS,
}) => {
  return (
      <Dialog open={isCreateCategoryModalOpen} onOpenChange={setIsCreateCategoryModalOpen}>
        <DialogContent
          data-testid="create-category-modal"
          closeButtonTestId="create-category-modal-close-button"
          className="glass-modal max-w-md"
        >
          <DialogHeader>
            <DialogTitle className="text-white text-xl">Nova Categoria</DialogTitle>
          </DialogHeader>
          
          <form onSubmit={handleCreateCategoryInline} className="space-y-4">
            {/* Nome da Categoria */}
            <div>
              <label className="block text-base font-medium text-gray-300 mb-2">
                Nome da Categoria *
              </label>
              <input
                type="text"
                required
                className="glass-input w-full text-base py-3 px-4"
                value={newCategoryData.name}
                onChange={(e) => setNewCategoryData({...newCategoryData, name: e.target.value})}
                placeholder="Ex: Lanches, Bebidas, Sobremesas..."
                data-testid="inline-category-name-input"
                autoFocus
              />
            </div>

            {/* Descrição */}
            <div>
              <label className="block text-base font-medium text-gray-300 mb-2">
                Descrição (opcional)
              </label>
              <textarea
                className="glass-input w-full resize-none text-base py-3 px-4"
                rows={2}
                value={newCategoryData.description}
                onChange={(e) => setNewCategoryData({...newCategoryData, description: e.target.value})}
                placeholder="Breve descrição da categoria"
                data-testid="inline-category-description-input"
              />
            </div>

            {/* Seletor de Cor */}
            <div>
              <label className="block text-base font-medium text-gray-300 mb-2">
                Cor da Categoria
              </label>
              <div className="flex flex-wrap gap-2">
                {COLOR_OPTIONS.map((color) => (
                  <button
                    key={color.value}
                    type="button"
                    className={`w-10 h-10 rounded-lg border-2 transition-all ${
                      newCategoryData.color === color.value 
                        ? 'border-white scale-110 shadow-lg' 
                        : 'border-gray-600 hover:border-gray-400 hover:scale-105'
                    }`}
                    style={{ backgroundColor: color.color }}
                    onClick={() => setNewCategoryData({...newCategoryData, color: color.value})}
                    title={color.label}
                    data-testid={`inline-category-color-${color.label}`}
                  />
                ))}
              </div>
              <p className="text-xs text-gray-500 mt-2">
                Cor selecionada: <span className="font-medium" style={{ color: newCategoryData.color }}>
                  {COLOR_OPTIONS.find(c => c.value === newCategoryData.color)?.label}
                </span>
              </p>
            </div>

            {/* Botões de Ação */}
            <div className="flex gap-3 pt-4 border-t border-gray-800">
              <button
                type="button"
                onClick={() => {
                  setIsCreateCategoryModalOpen(false);
                  setNewCategoryData({ name: '', description: '', color: '#3b82f6' });
                }}
                className="flex-1 px-4 py-3 text-base text-gray-400 hover:text-white transition-colors rounded-xl border border-gray-700 hover:border-gray-600"
                disabled={creatingCategory}
                data-testid="inline-category-cancel-button"
              >
                Cancelar
              </button>
              <button 
                type="submit" 
                className="flex-1 glass-button-primary py-3 px-6 text-base font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                disabled={creatingCategory || !newCategoryData.name.trim()}
                data-testid="inline-category-submit-button"
              >
                {creatingCategory ? 'Criando...' : '✓ Criar Categoria'}
              </button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

  );
};

export default CreateCategoryModal;
